import { Component, Host, Optional, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Route, Router, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { MpsPermissionHelper } from '../../helpers/mps-permission.helper';
import { MpsUserService } from '../../services/mps-user.service';
import { globalRouteNames } from '../../../app/shared/global-route-names';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'mps-app-navigation',
  templateUrl: './mps-navigation.component.html',
  styleUrls: ['./mps-navigation.component.scss'],
  imports: [TranslateModule, MatIconModule, MatMenuModule, RouterModule],
})
export class MpsNavigationComponent {
  private readonly _routes: Route[] = [];
  private _userService = inject(MpsUserService);
  private _router = inject(Router);

  constructor(@Host() @Optional() private _sidenav: MatSidenav) {
    this._routes = this._router.config;
  }

  public getRoutes(): Route[] {
    return this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }

  navigateToChild(parentPath: string | undefined, item: Route) {
    if (item.data?.externalLink) {
      window.open(item.data?.externalLink, '_blank');
    } else {
      if (!parentPath) {
        console.warn(`Parent path is not defined for child route: ${item.path}, setting it to root.`);
        parentPath = globalRouteNames.root;
      }
      this._router.navigate([parentPath, item.path]);
    }
  }

  isMenuItemDisplayed(route: Route): boolean {
    const user = this._userService.getUserSubject().getValue();
    if (!user) {
      return false;
    }

    const hasTitle = route.data?.['title'];
    const canUserActivate = MpsPermissionHelper.canUserActivate(user, route);

    return hasTitle && canUserActivate;
  }

  isChildRouteActive(route: Route): boolean {
    if (!route || !route.children) {
      return false;
    }
    // Check if any child route is active
    return route.children.some((child: Route) =>
      this._router.isActive(this._router.createUrlTree([route.path, child.path]), {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })
    );
  }
}
